"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TagPickerOptionGroup: function() {
        return _index.TagPickerOptionGroup;
    },
    renderTagPickerOptionGroup: function() {
        return _index.renderTagPickerOptionGroup;
    },
    tagPickerOptionGroupClassNames: function() {
        return _index.tagPickerOptionGroupClassNames;
    },
    useTagPickerOptionGroup: function() {
        return _index.useTagPickerOptionGroup;
    },
    useTagPickerOptionGroupStyles: function() {
        return _index.useTagPickerOptionGroupStyles;
    }
});
const _index = require("./components/TagPickerOptionGroup/index");
